<template>
  <section>
    <div
      id="myChart"
      ref="myChart"
      :style="{ height: boxHeight + 'rem' }"
    ></div>
  </section>
</template>

<script>
const colorList = ["#4992FF", "#58D9F9", "#7CFFB2"];

import * as echarts from "echarts";
export default {
  data() {
    return {
      myChart: null,
      dataValue: [],
      yName: [],
      mountData: "",
      updateData: "",
      fullDiv: {
        left: "0",
        right: "5%",
        bottom: "1%",
        top: "0%",
        containLabel: true,
      },
    };
  },
  props: {
    boxHeight: {
      default: 21,
      type: Number,
    },
    showtime: {
      default: false,
      type: Boolean,
    },
    showLegend: {
      default: false,
      type: Boolean,
    },
    coordinateName: {
      default: "",
      type: String,
    },
    graphicalRightData: {
      //是否显示图形右边的文字
      default: false,
      type: Boolean,
    },
  },

  components: {},

  mounted() {
    let that = this;
    // if (window.outerWidth <= 1920) {
    //   this.fullDiv = {
    //     left: "0",
    //     right: "0%",
    //     bottom: "1%",
    //     top: "10%",
    //     containLabel: true,
    //   };
    // }
    window.onresize = function () {
      that.myChart.resize();
    };
    // this.bus.$on("updatechartData", (content) => {
    //   this.dataValue = content;
    //   if (this.myChart) {
    //     this.myChart.setOption({
    //       series: [{ data: content.data }],
    //       yAxis: {
    //         data: content.yName,
    //       },
    //     });
    //   }
    // });
    // this.bus.$on("initchartData", (content) => {
    //   this.mountData = content;
    //   this.myEcharts();
    // });
    // this.myEcharts();
  },
  watch: {},
  methods: {
    upDateChart(content) {
      console.log("content", content);
      this.myChart.setOption({
        series: [
          {
            data: content.data,
            label: {
              formatter: function (params) {
                return (params.data = content.yName[params.dataIndex]);
              },
            },
          },
        ],
        yAxis: [
          {
            data: (() => {
              if (this.graphicalRightData) {
                let list = [];
                content.yName.map((y, y_index) => {
                  list.push(y_index + 1);
                });
                return list;
              } else {
                return content.yName;
              }
            })(),
          },
          {
            data: content.data,
          },
        ],
      });
    },
    myEcharts(data) {
      let echarts = require("echarts");
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(this.$refs.myChart);
      this.setChartData(data);
      // 指定图表的配置项和数据
    },
    setChartData(data) {
      console.log("data", data);
      let option = {
        xAxis: {
          //   max: "dataMax",
          // name: this.coordinateName ? this.coordinateName : "",
          splitLine: {
            show: false,
          },
          axisLabel: {
            fontSize: this.$common.setFontSize(0.92),
          },
          nameTextStyle: {
            fontSize: this.$common.setFontSize(0.77),
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: [
          {
            type: "category",
            data: (() => {
              if (this.graphicalRightData) {
                let list = [];
                data.yName.map((y, y_index) => {
                  list.push(y_index + 1);
                });
                return list;
              } else {
                return data.yName;
              }
            })(), //["A", "B", "C", "D", "E", "G"],
            inverse: true,
            // animationDuration: 0,
            // animationDurationUpdate: 0,
            axisTick: {
              // show: false, //不显示坐标轴刻度线
            },
            axisLine: {
              // show: false, //不显示坐标轴线
            },
            axisLabel: {
              // show: false, //不显示坐标轴上的文字
              show: true,
              color: "#fff",
              fontSize: this.$common.setFontSize(0.92),
            },
            splitLine: {
              //网格线
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            // max: 2 // only the largest 3 bars will be displayed
          },
          {
            type: "category",
            data: data.data, //["A", "B", "C", "D", "E", "G"],
            inverse: true,
            // animationDuration: 300,
            // animationDurationUpdate: 300,
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              margin: 80,
              show: true,
              color: "#fff",
              fontSize: this.$common.setFontSize(0.92),
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#fff",
              },
            },
            // max: 2 // only the largest 3 bars will be displayed
          },
        ],
        dataZoom: [
          // {
          //   type: "inside",
          // },
          {
            show: false,
            yAxisIndex: 0,
            filterMode: "empty",
            width: 30,
            height: "80%",
            showDataShadow: false,
            left: "93%",
          },
        ],
        series: [
          {
            realtimeSort: true,
            // name: "X",
            type: "bar",
            barWidth: 5,
            data: data.data, //dataArr,
            // itemStyle: {
            //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //     { offset: 0, color: "#83bff6" },
            //     { offset: 0.5, color: "#188df0" },
            //     { offset: 1, color: "#188df0" },
            //   ]),
            // },
            itemStyle: {
              color: function (param) {
                // console.log("param", param);
                return colorList[param.dataIndex % 3];
              },
            },
            label: {
              show: this.graphicalRightData,
              position: "right",
              valueAnimation: true,
              color: "#FFFFFF",
              fontSize: this.$common.setFontSize(0.92),
              formatter: function (params) {
                return (params.data = data.yName[params.dataIndex]);
              },
              // formatter: (()=>{
              //   return "{`123`}{b}: {@score}"
              // })() ,
            },
          },
        ],
        legend: {
          show: this.showLegend,
        },
        tooltip: {
          show: true,
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          backgroundColor: "rgba(0,0,0,0.3)",
          borderWidth: "0",
          textStyle: {
            color: "#fff",
            fontSize: this.$common.setFontSize(0.9),
          },
          formatter: function (params) {
            let paramsData = params[0];
            return `<div>${data.yName[paramsData.dataIndex]}排放量：<span style="font-weight:bold">${
              paramsData.data
            }万吨</span></div>`;
          },
        },
        grid: this.fullDiv,
        // animationDuration: 0,
        // animationDurationUpdate: 3000,
        // animationEasing: "linear",
        // animationEasingUpdate: "linear",
      };

      // 使用刚指定的配置项和数据显示图表。
      this.myChart.setOption(option);
    },
  },
  destroyed() {
    // this.bus.$off("updateData");
  },
};
</script>
<style lang='scss' scoped>
</style>